<template>
  <Content id="fieldConfig">
    <div slot="search">
      <Form :label-width="70" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="字段名称"><Input v-model="search.name" maxlength="50"/></FormItem></Col>
          <Col>
            <FormItem label="体检项目" :label-width="75">
              <Select v-model="search.projectId" style="min-width: 120px" :clearable="true">
                <Option v-for="item in projectNames" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="业务类型" :label-width="75">
              <Select v-model="search.businessType" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in businessTypeList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态" :label-width="50">
              <Select v-model="search.status" style="min-width: 75px;" :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
          <Button size="small" style="margin-left: 5px;" icon="ios-paper-outline" @click="handleCopy" type="primary">复制模版</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row :max-height="tableHeight">

      <el-table-column fixed align="center" prop="name" label="名称" min-width="80">
        <template slot-scope="{row}">{{ row.name }}</template>
      </el-table-column>
      <el-table-column fixed align="center" prop="alias" label="别名" min-width="80"/>
      <el-table-column fixed align="center" prop="code" label="编码" min-width="80"/>
      <el-table-column fixed align="center" prop="defaultValue" label="默认值" min-width="80"/>
      <el-table-column fixed align="center" prop="columnNumber" label="占列数" min-width="80"/>
      <el-table-column fixed align="center" prop="80" label="单位" min-width="80"/>
      <el-table-column align="center" prop="gender" label="性别" min-width="80">
        <template slot-scope="{row}">{{ row.gender ? row.gender == 1 ? '男' : '女' : '' }}</template>
      </el-table-column>
      <el-table-column align="center" prop="isRead" label="只读" min-width="80">
        <template slot-scope="{row}">{{ enums.isOrNot.filter(u => u.value === row.isRead)[0].label }}</template>
      </el-table-column>
      <el-table-column align="center" prop="isRequired" label="必填" min-width="50">
        <template slot-scope="{row}">{{ enums.isOrNot.filter(u => u.value === row.isRequired)[0].label }}</template>
      </el-table-column>
      <el-table-column align="center" prop="projectName" label="体检项目" min-width="80"/>
      <el-table-column align="center" prop="businessType" label="业务类型" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" type="success" disable-transitions>
            {{
              row.businessType ? (row.businessType == 1 ? '通用' : row.businessType == 2 ? '幼儿园' : row.businessType == 3 ? '小学' : row.businessType == 4 ? '中学' :  row.businessType == 5 ? '大学' : '') : ''
            }}
          </el-tag>
        </template>
      </el-table-column>
<!--      <el-table-column align="center" prop="remark" label="备注" min-width="80"/>-->
      <el-table-column align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作" min-width="80" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="dialogVisible" :title="dialogTitle" style="top:60px;text-align:center;" width="40%" :mask-closable="false" :max-height="maxHeight">
      <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入" v-model="fieldIds" :data="tempalteList" :titles="['选项', '已选择']"/>
      <div slot="footer">
        <Button @click="dialogVisible = false">取消</Button>
        <Button type="primary" @click="saveTempalte" :disabled="importDisabled">确定</Button>
      </div>
    </Modal>

    <Modal v-model="editWindow" width="40%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <FieldConfigEdit ref="edit" :style="{'max-height':maxHeight, 'overflow-y':'auto'}" @on-submit="handleSubmit" />
      <div slot="footer">
        <Button @click="editWindow = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {_page,_updateStatus, _generalField, _copyField} from "@/services/screeningConfig/fieldConfig.js";
import FieldConfigEdit from "./FieldConfigEdit";
import { mixins } from "@/mixins/index.js";
import {enums} from "@/services/enums";
import TaskDetailEdit from "@/views/preScreening/taskDetail/TaskDetailEdit.vue";
export default {
  name: "FieldConfig",
  mixins: [mixins],
  components: {
    TaskDetailEdit,
    FieldConfigEdit
  },
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      maxHeight: 0,
      currentRowIndex:null,
      search: {
        name: "",
        projectId: "",
        businessType: "",
        status: 1,
      },
      dataList: [],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0,
      },
      businessTypeList:[
        {label: '通用', value: 1},
        {label: '幼儿园', value: 2},
        {label: '小学', value: 3},
        {label: '中学', value: 4},
        {label: '大学', value: 5},
      ],
      fieldIds:[],
      tempalteList:[],
      dialogTitle:"模版详情",
      dialogVisible: false,
      importDisabled: false,
      enums:enums,
      editWindow:false,
      windowTitle:"新增",
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  async mounted() {
    if (!this.$userSession.checkInstitutionId()) {
      return;
    }

    this.generalField();
    await this.applyProjectName();
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
      this.maxHeight = `${height - 300}px`;
    },
    generalField(){
      this.tempalteList = [];
      _generalField().then(res => {
        if (res.errcode === 1) {
          res.data.forEach((item, index) => {
            this.tempalteList.push({
              // label: item.name + (item.flag ? "(" + item.flag + ")" : ""),
              label: item.name + (item.businessType ? (item.businessType == 1 ? ' -- 通用' : item.businessType == 2 ? ' -- 幼儿园' : item.businessType == 3 ? ' -- 小学' : item.businessType == 4 ? ' -- 中学' :  item.businessType == 5 ? ' -- 大学' : '') : ''),
              key: item.id
            });
          });
        }else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    saveTempalte(){
      if(!this.fieldIds||this.fieldIds.length==0){
        this.$message.warning('请先选择');
        return;
      }

      this.importDisabled = true;
      _copyField({fieldIds:this.fieldIds}).then(res => {
        if (res.errcode === 1) {
          this.$message.success("复制成功");
          this.handleDataList();
          this.dialogVisible = false;
          this.importDisabled = false;
        }else {
          this.importDisabled = false;
          this.$message.error(res.errmsg);
        }
      }).catch(res=>{
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    handleCopy(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.importDisabled = false;
      this.dialogVisible = true;
      this.fieldIds = [];

      /*_copyField().then(res => {
        if (res.errcode === 1) {
          this.$message.success("复制成功");
          this.handleDataList();
        }
      }).catch(() => {});*/
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _page({
        ...this.search,
        ...this.pageList
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(()=>{
            _updateStatus({fieldId:row.fieldId, status: targetValue}).then(res =>{
              if (res.errcode !== 1) {
                this.$message.error(res.errmsg);
                reject();
              }else{
                resolve()
              }
            }).catch(() => {
              reject();
            });
          }).finally(() => {
            this.handleDataList();
          })
        });
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e){
      this.pageList.currentPage=e
      this.handleDataList()
    },
    chagepagesize(e){
      this.pageList.pageSize=e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-transfer-panel .el-transfer-panel__header {text-align: left;}
/deep/ .el-transfer-panel__list.is-filterable {text-align: left;}
/deep/ .el-transfer-panel {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  overflow: hidden;
  background: #FFF;
  display: inline-block;
  vertical-align: middle;
  width: 250px;
  max-height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
</style>
